<script>
import TabBar from './tab-bar';
import { addResizeListener, removeResizeListener } from '../../utils/resize-event';

function noop () {}
const firstUpperCase = str => {
  return str.toLowerCase().replace(/( |^)[a-z]/g, L => L.toUpperCase());
};

export default {
  name: 'TabNav',

  components: {
    TabBar
  },

  inject: ['rootTabs'],

  props: {
    panes: Array,
    // currentName: String,
    editable: Boolean,
    onTabClick: {
      type: Function,
      default: noop
    },
    onTabRemove: {
      type: Function,
      default: noop
    },
    type: String,
    // 标签背景色，可选 lighter、primary、normal、success、warning、danger、info、secondary
    tabBgcolor: {
      type: String,
      default: 'white'
    },
    // 自定义边框颜色，可选 light、primary
    tabBordercolor: {
      type: String,
      default: 'base'
    },
    // 标签自定义选中状态背景颜色
    activeBgcolor: {
      type: String,
      default: 'white'
    },
    // 标签自定义选中状态边框的颜色
    activeBordercolor: {
      type: String,
      default: 'white'
    },

    stretch: Boolean,
    extraPosition: {
      type: String,
      default: 'right'
    },
    extraContent: Object
  },

  data () {
    return {
      scrollable: false,
      navOffset: 0,
      isFocus: false,
      focusable: true,
      extraWidth: 0, // 附加内容宽度
      hasExtraContent: null, // 是否拥有插槽 extraContent
      // eslint-disable-next-line vue/no-reserved-keys
      _resizeOb: null
    };
  },

  computed: {
    navStyle () {
      const style = {};
      const dir = ['top', 'bottom'].indexOf(this.rootTabs.tabPosition) !== -1 ? 'X' : 'Y';
      // 判断必须是按钮类型与tabButtonBg颜色不能为空-按钮标签页容器背景的borderRadius要和按钮标签保持一致
      if (this.rootTabs.type === 'button-card' && this.rootTabs.tabButtonBg) {
        style.borderRadius = `${this.rootTabs.borderRadius}px`;
      }
      if (this.hasExtraContent) {
        let navOffset = 0;
        if (this.navOffset !== 0) {
          navOffset = this.navOffset + this.extraWidth;
        }
        switch (this.extraPosition) {
          case 'right':
            style.transform = `translate${dir}(${navOffset}px)`;
            break;
          case 'left':
            style.transform = `translate${dir}(-${navOffset}px)`;
            break;
        }
      } else {
        style.transform = `translate${dir}(-${this.navOffset}px)`;
      }

      return style;
    },
    sizeName () {
      return ['top', 'bottom'].indexOf(this.rootTabs.tabPosition) !== -1 ? 'width' : 'height';
    },
    tabsStyle () {
      if (this.rootTabs.type === 'spacing-card') {
        return { margin: `0 ${this.rootTabs.spacing}px`, padding: `0 ${this.rootTabs.padding}px` };
      }
      // spacing标签左右外间距支持"button-card"-"spacing-card"两种类型按钮类型
      if (this.rootTabs.type === 'button-card') {
        return { borderRadius: `${this.rootTabs.borderRadius}px`, margin: `0 ${this.rootTabs.spacing}px` };
      }
      return { padding: `0 ${this.rootTabs.padding}px` };
    },
    computedStr () {
      return str => {
        const maxLen = this.rootTabs.maxLength || 7;
        let codeLen = 0;
        let len = str.length;
        for (let i = 0; i < len; i++) {
          const code = str.charCodeAt(i);
          if (code > 127) {
            codeLen++;
          }
          codeLen++;
          // 如果组件传值，就是用组件的值，否则使用默认值
          if (codeLen >= maxLen * 2) {
            len = i;
            break;
          }
        }
        if (len + 1 >= str.length) {
          return str;
        }
        return `${str.slice(0, len + 1)}...`;
      };
    }
  },

  updated () {
    this.update();
  },

  mounted () {
    addResizeListener(this.$el, this.update);
    document.addEventListener('visibilitychange', this.visibilityChangeHandler);
    window.addEventListener('blur', this.windowBlurHandler);
    window.addEventListener('focus', this.windowFocusHandler);
    setTimeout(() => {
      this.scrollToActiveTab();
      this.extraWidth = this.$refs.extraContent && this.$refs.extraContent.offsetWidth;
    }, 0);

    this.hasExtraContent =
    this.$options && this.$options.parent && this.$options.parent.$slots && this.$options.parent.$slots.extraContent;
    // 初始化标签页更新当前选中宽度
    this.handleTabUpdate()
  },

  beforeDestroy () {
    if (this.$el && this.update) removeResizeListener(this.$el, this.update);
    document.removeEventListener('visibilitychange', this.visibilityChangeHandler);
    window.removeEventListener('blur', this.windowBlurHandler);
    window.removeEventListener('focus', this.windowFocusHandler);
    // unobserve() 方法用于结束一个指定的 Element 或 SVGElement 的观察。
    if (this._resizeOb) {
      this._resizeOb.unobserve(this.$refs.nav);
    }
  },

  methods: {
    // 在插槽存在的时候-更新tab中-width的宽度
    handleTabUpdate  () {
      if (typeof ResizeObserver === 'function') {
        this._resizeOb = new ResizeObserver(() => {
          this.$parent.$emit('tab-nav-update');
        });
        // observe() 方法用于观察一个指定Element 或 SVGElement
        this._resizeOb.observe(this.$refs.nav);
      }
    },
    handleTabAdd () {
      this.$parent.$emit('edit', null, 'add');
      this.$parent.$emit('tab-add');
    },
    scrollPrev () {
      const containerSize = this.$refs.navScroll[`offset${firstUpperCase(this.sizeName)}`];
      const currentOffset = this.navOffset;

      if (!currentOffset) return;

      let newOffset = currentOffset > containerSize ? currentOffset - containerSize : 0;

      this.navOffset = newOffset;
    },
    scrollNext () {
      const navSize = this.$refs.nav[`offset${firstUpperCase(this.sizeName)}`];
      const containerSize = this.$refs.navScroll[`offset${firstUpperCase(this.sizeName)}`];
      const currentOffset = this.navOffset;

      if (navSize - currentOffset <= containerSize) return;

      let newOffset =
        navSize - currentOffset > containerSize * 2 ? currentOffset + containerSize : navSize - containerSize;

      this.navOffset = newOffset;
    },
    scrollToActiveTab () {
      if (!this.scrollable) return;
      const nav = this.$refs.nav;
      const activeTab = this.$el.querySelector('.is-active');
      if (!activeTab) return;
      const navScroll = this.$refs.navScroll;
      const isHorizontal = ['top', 'bottom'].indexOf(this.rootTabs.tabPosition) !== -1;
      const activeTabBounding = activeTab.getBoundingClientRect();
      const navScrollBounding = navScroll.getBoundingClientRect();
      const maxOffset = isHorizontal
        ? nav.offsetWidth - navScrollBounding.width
        : nav.offsetHeight - navScrollBounding.height;
      const currentOffset = this.navOffset;

      let newOffset = currentOffset;

      if (isHorizontal) {
        if (activeTabBounding.left < navScrollBounding.left) {
          newOffset = currentOffset - (navScrollBounding.left - activeTabBounding.left);
        }
        if (activeTabBounding.right > navScrollBounding.right) {
          newOffset = currentOffset + activeTabBounding.right - navScrollBounding.right;
        }
      } else {
        if (activeTabBounding.top < navScrollBounding.top) {
          newOffset = currentOffset - (navScrollBounding.top - activeTabBounding.top);
        }
        if (activeTabBounding.bottom > navScrollBounding.bottom) {
          newOffset = currentOffset + (activeTabBounding.bottom - navScrollBounding.bottom);
        }
      }
      newOffset = Math.max(newOffset, 0);
      this.navOffset = Math.min(newOffset, maxOffset);
    },
    update () {
      if (!this.$refs.nav) return;
      const sizeName = this.sizeName;
      const navSize = this.$refs.nav[`offset${firstUpperCase(sizeName)}`];
      const containerSize = this.$refs.navScroll[`offset${firstUpperCase(sizeName)}`];
      const currentOffset = this.navOffset;

      if (containerSize < navSize) {
        const _currentOffset = this.navOffset;
        this.scrollable = this.scrollable || {};
        this.scrollable.prev = _currentOffset;
        this.scrollable.next = _currentOffset + containerSize < navSize;
        if (navSize - _currentOffset < containerSize) {
          this.navOffset = navSize - containerSize;
        }
      } else {
        this.scrollable = false;
        if (currentOffset > 0) {
          this.navOffset = 0;
        }
      }
    },
    changeTab (e) {
      const keyCode = e.keyCode;
      let nextIndex;
      let currentIndex, tabList;
      if ([37, 38, 39, 40].indexOf(keyCode) !== -1) {
        // 左右上下键更换tab
        tabList = e.currentTarget.querySelectorAll('[role=tab]');
        currentIndex = Array.prototype.indexOf.call(tabList, e.target);
      } else {
        return;
      }
      if (keyCode === 37 || keyCode === 38) {
        // left
        if (currentIndex === 0) {
          // first
          nextIndex = tabList.length - 1;
        } else {
          nextIndex = currentIndex - 1;
        }
      } else {
        // right
        if (currentIndex < tabList.length - 1) {
          // not last
          nextIndex = currentIndex + 1;
        } else {
          nextIndex = 0;
        }
      }
      tabList[nextIndex].focus(); // 改变焦点元素
      tabList[nextIndex].click(); // 选中下一个tab
      this.setFocus();
    },
    setFocus () {
      if (this.focusable) {
        this.isFocus = true;
      }
    },
    removeFocus () {
      this.isFocus = false;
    },
    visibilityChangeHandler () {
      const visibility = document.visibilityState;
      if (visibility === 'hidden') {
        this.focusable = false;
      } else if (visibility === 'visible') {
        setTimeout(() => {
          this.focusable = true;
        }, 50);
      }
    },
    windowBlurHandler () {
      this.focusable = false;
    },
    windowFocusHandler () {
      setTimeout(() => {
        this.focusable = true;
      }, 50);
    }
  },

  render (h) {
    const {
      type,
      panes,
      stretch,
      onTabClick,
      onTabRemove,
      navStyle,
      tabsStyle,
      scrollable,
      scrollNext,
      scrollPrev,
      changeTab,
      setFocus,
      removeFocus,
      extraPosition,
      handleTabAdd,
      editable,
      addable
    } = this;
    const newButton =
      editable || addable ? (
        <span
          class={['rt-tabs__new-tab', 'el-tabs__new-tab']}
          on-click={handleTabAdd}
          tabindex="0"
          on-keydown={ev => {
            if (ev.keyCode === 13) {
              handleTabAdd();
            }
          }}
        >
          <rt-icon name="rt-base-plus"></rt-icon>
        </span>
      ) : null;
    const scrollBtn = scrollable
      ? [
        <span
          class={['rt-tabs__nav-prev', 'el-tabs__nav-prev', scrollable.prev ? '' : 'is-disabled']}
          on-click={scrollPrev}
        >
          <i class="el-icon-arrow-left"></i>
        </span>,
        <span
          class={['rt-tabs__nav-next', 'el-tabs__nav-next', scrollable.next ? '' : 'is-disabled']}
          on-click={scrollNext}
        >
          <i class="el-icon-arrow-right"></i>
        </span>
      ]
      : null;

    // 附加内容
    const extraContent = this.hasExtraContent
      ? [
        <div
          ref="extraContent"
          class={{
            'tabs-nav_extra-content': true,
            'tabs-nav_extra-content__border': this.rootTabs.border
          }}
        >
          {this.hasExtraContent}
        </div>
      ]
      : null;

    const tabs = this._l(panes, (pane, index) => {
      let tabName = pane.name || pane.index || index;
      const closable = pane.isClosable || editable;

      pane.index = `${index}`;

      const btnClose = closable ? (
        <rt-icon
          class="rt-icon-close"
          name="rt-base-close-x-lined"
          size="16"
          on-click={ev => {
            onTabRemove(pane, ev);
          }}
        ></rt-icon>
      ) : null;

      // 文字超出显示省略号默认字符长度为7
      const tabLabelContent = pane.$slots.label || this.computedStr(pane.label);
      const tabindex = pane.active ? 0 : -1;
      return (
        <div
          class={{
            'rt-tabs__item': true,
            'el-tabs__item': true,
            [`is-${this.rootTabs.tabPosition}`]: true,
            [`is-textcolor-${this.rootTabs.tabTextColor}`]: !!this.rootTabs.tabTextColor,
            [`is-bgcolor__${this.rootTabs.tabBgcolor}`]: !!this.rootTabs.tabBgcolor,
            [`is-border-color__${this.rootTabs.tabBordercolor}`]: !!this.rootTabs.tabBordercolor,
            [`is-active-bgcolor__${this.rootTabs.activeBgcolor}`]: !!pane.active,
            [`is-active-bodercolor__${this.rootTabs.activeBordercolor}`]: !!pane.active,
            'is-active': pane.active,
            'is-disabled': pane.disabled,
            'is-closable': closable,
            'is-focus': this.isFocus
          }}
          style={tabsStyle}
          id={`tab-${tabName}`}
          key={`tab-${tabName}`}
          aria-controls={`pane-${tabName}`}
          role="tab"
          aria-selected={pane.active}
          ref="tabs"
          tabindex={tabindex}
          refInFor
          on-focus={() => {
            setFocus();
          }}
          on-blur={() => {
            removeFocus();
          }}
          on-click={ev => {
            removeFocus();
            onTabClick(pane, tabName, ev);
          }}
          on-keydown={ev => {
            if (closable && (ev.keyCode === 46 || ev.keyCode === 8)) {
              onTabRemove(pane, ev);
            }
          }}
        >
          {tabLabelContent}
          {btnClose}
        </div>
      );
    });
    return (
      <div
        class={[
          'rt-tabs__nav-wrap',
          'el-tabs__nav-wrap',
          scrollable ? 'is-scrollable' : '',
          `is-${this.rootTabs.tabPosition}`
        ]}
      >
        {scrollBtn}
        <div
          class={{
            'rt-tabs__nav-scroll': true,
            'el-tabs__nav-scroll': true,
            [`extra-content__${extraPosition}`]: this.hasExtraContent
          }}
          ref="navScroll"
        >
          {extraContent}
          <div
            class={[
              'rt-tabs__nav',
              'el-tabs__nav',
              `is-tabbuttonbg__${this.rootTabs.tabButtonBg}`,
              `is-${this.rootTabs.tabPosition}`,
              stretch && ['top', 'bottom'].indexOf(this.rootTabs.tabPosition) !== -1 ? 'is-stretch' : ''
            ]}
            ref="nav"
            style={navStyle}
            role="tablist"
            on-keydown={changeTab}
          >
            {!type ? <tab-bar tabs={panes}></tab-bar> : null}
            {tabs}
            {newButton}
          </div>
        </div>
      </div>
    );
  }
};
</script>



// WEBPACK FOOTER //
// tab-nav.vue?8f7a52a4